import { render, staticRenderFns } from "./PageNoticeRead.vue?vue&type=template&id=b56ceebe&scoped=true&"
import script from "./PageNoticeRead.vue?vue&type=script&lang=js&"
export * from "./PageNoticeRead.vue?vue&type=script&lang=js&"
import style0 from "./PageNoticeRead.vue?vue&type=style&index=0&id=b56ceebe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56ceebe",
  null
  
)

export default component.exports